import { Container, Graphics, RenderTexture, Renderer, SCALE_MODES, Sprite } from "pixi.js";
import { MyBuildingsResourcePackage } from "../resources/MyBuildingsResourcePackage";

export class ArcGradient extends Container {
    private readonly renderTexture: RenderTexture;
    private readonly graphics: Graphics;

    public constructor(renderer: Renderer, myBuildingResources: MyBuildingsResourcePackage, radius: number) {
        super();
        const gradientSprite = new Sprite(myBuildingResources.assets_views_mybuildings_ui_upgrade_linear_gradient_png);
        gradientSprite.width = Math.floor(2 * Math.PI * radius);
        this.renderTexture = RenderTexture.create({
            width: gradientSprite.width,
            height: 1,
            scaleMode: SCALE_MODES.LINEAR,
            resolution: 1
        });
        renderer.render(gradientSprite, { renderTexture: this.renderTexture });
        this.graphics = new Graphics();
        this.graphics.lineTextureStyle({ width: 6, texture: this.renderTexture });
        this.graphics.arc(0, 0, 305, - Math.PI / 18, Math.PI + Math.PI / 18);
        this.addChild(this.graphics);
    }
}